import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Box, Grid, Paper, Typography, CircularProgress, TextField, MenuItem, Checkbox, Pagination, InputAdornment } from '@mui/material';
import ApiService from "../../functions/apiService";
import { Col, Row } from 'react-bootstrap';
import moment from 'moment';
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import { toast } from 'react-toastify';
import './payroll.css'
import ButtonDatePicker from '../../components/DatePickers/ButtonDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import Multiselect from 'multiselect-react-dropdown';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";

const AddPayroll = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [employees, setEmployees] = useState([])
  const [reasonList, setReasonList] = useState([])
  const [payCode, setPayCode] = useState([])

  const [payrollData, setPayrollData] = useState({
    emp: [],
    payroll_date: new Date(),
    run_num: '',
    reason: '',
    desc: '',
    pay_code: '',
    start_time: null,
    end_time: null,
    duration: '',
  });

  const getMemeberList = async () => {
    setLoading(true);
    try {
      const response = await ApiService.get("/employees-list", {
      });
      setEmployees(response.data.data || [])
    } catch (error) {
      console.error(error.data)
    }
    finally {
      setLoading(false)
    }
  };
  const getReasonList = async () => {
    setLoading(true);
    try {
      const response = await ApiService.get("/payroll/add-payroll", {
      });
      setReasonList(response.data || [])
    } catch (error) {
      console.error(error.data)
    }
    finally {
      setLoading(false)
    }
  };
  const getPayCodeList = async () => {
    setLoading(true);
    try {
      const response = await ApiService.get("/payroll/pay-code", {
      });
      setPayCode(response.data || [])
    } catch (error) {
      console.error(error.data)
    }
    finally {
      setLoading(false)
    }
  };

  useEffect(() => {
    getMemeberList()
    getReasonList()
    getPayCodeList()
  }, [])

  const roundToStep = (value, step = 0.5) => {
  // rounds to nearest step (0.5 => 0.0, 0.5, 1.0, 1.5, ...)
  return Math.round(value / step) * step;
};

const handleChange = (field, value) => {
  let updatedData = {
    ...payrollData,
    [field]: value,
  };

  const { start_time, end_time } = updatedData;

  if (start_time && end_time) {
    let start = new Date(start_time);
    let end = new Date(end_time);

    // If end is before/equal start, assume overnight shift and add 1 day to end
    if (end <= start) {
      end.setDate(end.getDate() + 1);
    }

    const rawHours = (end - start) / 1000 / 60 / 60; // float hours
    const roundedHours = roundToStep(rawHours, 0.25); // nearest 0.5

    // store as number (better for backend), display can use toFixed(2)
    updatedData.duration = Number(roundedHours.toFixed(2));
  } else {
    updatedData.duration = 0;
  }

  setPayrollData(updatedData);
};

  const handleCancel = () => {
    setPayrollData({
      emp: [],
      payroll_date: new Date(),
      run_num: '',
      reason: '',
      desc: '',
      pay_code: '',
      start_time: null,
      end_time: null,
      duration: '',
    })
  }

  const handleSubmit = async () => {
    setLoading(true);
    let updatedData = payrollData

    updatedData['payroll_date'] = moment(updatedData.payroll_date).format("YYYY-MM-DD");
    updatedData['start_time'] = moment(updatedData.start_time).format("HH:mm:ss");
    updatedData['end_time'] = moment(updatedData.end_time).format("HH:mm:ss");

    try {
      const response = await ApiService.post("/payroll/addpayroll", updatedData);
      toast.success(response.message)
      navigate('/firehouse/payroll');
    } catch (error) {
      toast.error(error.data.message);
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading ? (
        <Paper className="w-100 h-100 d-flex justify-content-center align-items-center">
          <CircularProgress />
        </Paper>
      ) : (
        <Paper className="p-4" style={{ marginTop: "1rem" }}>
          <div>
            <Grid container spacing={0} alignItems="center" justifyContent="space-between">
              <Grid item xs={3}>
                <Typography variant="h5">
                  <Link to="/firehouse/payroll" style={{ color: "black" }}>
                    <ArrowBackIosIcon />
                  </Link>Add Payroll Record</Typography>
              </Grid>
            </Grid>
          </div>
          <Row className='w-100' style={{ flexWrap: 'wrap' }}>
            <Col md={4}>
              <label className='my-2'>Members</label>
              <Multiselect
                className="custom-multiselect"
                displayValue='label'
                options={employees.map((emp) => ({
                  label: emp.fullName,
                  value: emp.Emp_Code
                }))}
                showCheckbox
                showArrow
                customCloseIcon={<><img src='/images/cross.png' /></>}
                placeholder='Members'
                onSelect={(selectedList) => handleChange("emp", selectedList.map(item => item.value))}
                selectedValues={payrollData.emp.map(empCode => ({
                  label: employees.find(emp => emp.Emp_Code === empCode)?.fullName,
                  value: empCode
                }))}
              />
            </Col>
            <Col md={4} className='d-grid'>
              <label className='my-2'>Date</label>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <ButtonDatePicker
                  className='w-100'
                  label={moment(payrollData.payroll_date).format('MM-DD-YYYY')}
                  value={new Date(payrollData.date)}
                  onChange={(e) => handleChange("payroll_date", moment(e).format('YYYY-MM-DD'))}
                  //minDate={new Date()}
                  style={{ height: "48px" }}
                />
              </LocalizationProvider>
            </Col>
            <Col md={4}>
              <label className='my-2'>Run</label>
              <TextField
                className='w-100' color='secondary' variant="outlined"
                label="Run"
                sx={{ height: "48px", "& .MuiInputBase-root": { height: "48px" } }}
                value={payrollData.run_num}
                onChange={(e) => handleChange("run_num", e.target.value)}
              />
            </Col>
            <Col md={4} className='mb-4'>
              <label className='my-2'>Reason</label>
              <TextField
                className="custom-multiselect d-block"
                displayValue='label'
                label="Select Reason"
                options={payCode.map((item) => ({
                  label: item.SO_Desc,
                  value: item.SO_Value,
                }))
                }
                color="secondary"
                variant="outlined"
                select
                size='medium'
                InputProps={{
                  sx: {
                    width: "100%",
                    height: '48px',
                  }
                }}
                value={payrollData.reason}
                onChange={(e) => handleChange("reason", e.target.value)}
              >
                {reasonList.map((item) => (
                  <MenuItem key={item.SO_Value} value={item.SO_Value}>
                    {item.SO_Value}
                  </MenuItem>
                ))}

              </TextField>

            </Col>
            <Col md={4}>
              <label className='my-2'>Description</label>
              <TextField
                className='w-100' color='secondary' variant="outlined"
                label="Description"
                sx={{ height: "48px", "& .MuiInputBase-root": { height: "48px" } }}
                value={payrollData.desc}
                onChange={(e) => handleChange("desc", e.target.value)} s
              />
            </Col>
            <Col md={4}>
              <label className='my-2'>Pay Code</label>
              <TextField
                className="custom-multiselect d-block"
                displayValue='label'
                label="Select Pay Code"
                options={payCode.map((item) => ({
                  label: item.SO_Desc,
                  value: item.SO_Value,
                }))
                }
                color="secondary"
                variant="outlined"
                select
                size='medium'
                InputProps={{
                  sx: {
                    width: "100%",
                    height: '48px',
                  }
                }}
                value={payrollData.pay_code}
                onChange={(e) => handleChange("pay_code", e.target.value)}
              >
                <MenuItem value={"STRAIGHT"}>
                  Straight
                </MenuItem>
                <MenuItem value={"OVERTIME"}>
                  Overtime
                </MenuItem>
                {payCode.map((item) => (
                  <MenuItem key={item.SO_Value} value={item.SO_Value}>
                    {item.SO_Desc}
                  </MenuItem>
                ))}

              </TextField>
              {/* <Multiselect
                className="custom-multiselect"
                displayValue='label'
                options={payCode.map((item) => ({
                  label: item.SO_Desc,
                  value: item.SO_Value,
                }))
                }
                showCheckbox
                showArrow
                customCloseIcon={<><img src='/images/cross.png' /></>}
                placeholder='Pay Code'
                onSelect={(selectedList) => handleChange("pay_code", selectedList)}
                selectedValues={payrollData.pay_code}
              /> */}
            </Col>
            <Col md={4}>
              <label className='my-2'>Start Time</label>
              <Box>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <TimePicker
                    className="m-0"
                    timeSteps={{ minutes: 10 }}
                    value={payrollData.start_time}
                    onChange={(newValue) => handleChange("start_time", newValue)}
                    // maxTime={payrollData.end_time || null}
                    sx={{
                      "& .MuiOutlinedInput-input": { color: 'red' },
                      width: "100%",
                      "& .MuiInputBase-root": {
                        height: '48px',
                        fontSize: '14px'
                      },
                    }}
                  />
                </LocalizationProvider>
              </Box>
            </Col>
            <Col md={4}>
              <label className='my-2'>End Time</label>
              <Box>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <TimePicker
                    className="m-0"
                    timeSteps={{ minutes: 10 }}
                    value={payrollData.end_time}
                    onChange={(newValue) => handleChange("end_time", newValue)}
                    // minTime={payrollData.start_time || null}
                    sx={{
                      "& .MuiOutlinedInput-input": { color: 'red' },
                      width: "100%",
                      "& .MuiInputBase-root": {
                        height: '48px',
                        fontSize: '14px'
                      },
                    }}
                  />
                </LocalizationProvider>
              </Box>
            </Col>
            <Col md={4}>
              <label className='my-2'>Hours</label>
              <TextField
                className='w-100' color='secondary' variant="outlined"
                label="Hours"
                sx={{ height: "48px", "& .MuiInputBase-root": { height: "48px" } }}
                value={payrollData.duration}
              // onChange={(e) => handleChange("duration", e.target.value)}
              // value={
              //   payrollData.start_time && payrollData.end_time &&
              //     new Date(payrollData.end_time) > new Date(payrollData.start_time)
              //     ? (
              //       (new Date(payrollData.end_time) - new Date(payrollData.start_time)) / 1000 / 60 / 60
              //     ).toFixed(2)
              //     : 0
              // }
              />
            </Col>
          </Row>
          <div className='d-flex gap-3 align-items-center mt-4'>
            <div>
              <ButtonTheme onClick={handleSubmit} variant="filled" color='primary' style={{ height: 38 }}>
                Create
              </ButtonTheme>
            </ div>
            <div >
              <ButtonTheme onClick={handleCancel} variant="filled" color='primary' style={{ height: 38 }}>
                Cancel
              </ButtonTheme>
            </ div>
          </div>
        </Paper >
      )}
    </>
  )
}

export default AddPayroll;